import { render, staticRenderFns } from "./CatalogProductSetting.vue?vue&type=template&id=53263116&scoped=true&"
import script from "./CatalogProductSetting.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSetting.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSetting.vue?vue&type=style&index=0&id=53263116&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53263116",
  null
  
)

export default component.exports